import {Plan} from "../../../types";
import {ValidationMessage, MessageOpts} from "../../types";
import {validateLidHeight} from "../rules/lidHeightValidation";

export const getLidHeightErrorMessages = (plan: Plan, opts: MessageOpts): ValidationMessage[] => {
    const {
        resolveLocation,
        resolveLocationText,
        severity = 'error',
    } = opts;
    const validationResult = validateLidHeight(plan);

    if (validationResult.ok) return [];
    return [
        {
            message: `Die Mindest-Abdeckunghöhe von ${validationResult.minHeight} cm wurde unterschritten`,
            severity: severity,
            ...(resolveLocation ? {resolveLocation} : {}),
            ...(resolveLocationText ? {resolveLocationText} : {}),
        }
    ]
}

export const getLidHeightError = (plan: Plan): string | null => {
    const validationResult = validateLidHeight(plan);

    if (validationResult.ok) return null;
    return `Die Mindesthöhe von ${validationResult.minHeight} cm wurde unterschritten`;
}